/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as AuthRouteRouteImport } from './routes/auth/route'
import { Route as OperatorRouteRouteImport } from './routes/operator/route'
import { Route as AppPlatformRouteRouteImport } from './routes/_app/_platform/route'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as AuthInvitationRouteImport } from './routes/auth/invitation'
import { Route as AuthMfaRouteImport } from './routes/auth/mfa'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthSetup2faRouteImport } from './routes/auth/setup-2fa'
import { Route as AuthSignInRouteImport } from './routes/auth/sign-in'
import { Route as AuthSignedOutRouteImport } from './routes/auth/signed-out'
import { Route as AuthSocialRouteImport } from './routes/auth/social'
import { Route as AuthVerifyEmailRouteImport } from './routes/auth/verify-email'
import { Route as OperatorIndexRouteImport } from './routes/operator/index'
import { Route as OperatorConfigurationRouteImport } from './routes/operator/configuration'
import { Route as OperatorJobsRouteImport } from './routes/operator/jobs'
import { Route as OperatorPlansRouteImport } from './routes/operator/plans'
import { Route as OperatorSecurityRouteImport } from './routes/operator/security'
import { Route as AppPlatformIndexRouteImport } from './routes/_app/_platform/index'
import { Route as AppPlatformNotificationsRouteImport } from './routes/_app/_platform/notifications'
import { Route as OperatorOrganizationsIndexRouteImport } from './routes/operator/organizations.index'
import { Route as OperatorOrganizationsOrganizationIdRouteImport } from './routes/operator/organizations.$organizationId'
import { Route as AppPlatformAccountIndexRouteImport } from './routes/_app/_platform/account.index'
import { Route as AppPlatformAccountSecurityRouteImport } from './routes/_app/_platform/account.security'
import { Route as AppPlatformHelpIndexRouteImport } from './routes/_app/_platform/help.index'
import { Route as AppPlatformHelpTopicRouteImport } from './routes/_app/_platform/help.$topic'
import { Route as AppOOrganizationIdPlatformRouteRouteImport } from './routes/_app/o/$organizationId/_platform/route'
import { Route as AppOOrganizationIdSettingsRouteRouteImport } from './routes/_app/o/$organizationId/settings/route'
import { Route as AppOOrganizationIdPlatformIndexRouteImport } from './routes/_app/o/$organizationId/_platform/index'
import { Route as AppOOrganizationIdSettingsIndexRouteImport } from './routes/_app/o/$organizationId/settings/index'
import { Route as AppOOrganizationIdSettingsActivityRouteImport } from './routes/_app/o/$organizationId/settings/activity'
import { Route as AppOOrganizationIdSettingsBillingRouteImport } from './routes/_app/o/$organizationId/settings/billing'
import { Route as AppOOrganizationIdSettingsBrandingRouteImport } from './routes/_app/o/$organizationId/settings/branding'
import { Route as AppOOrganizationIdSettingsDataRouteImport } from './routes/_app/o/$organizationId/settings/data'
import { Route as AppOOrganizationIdSettingsMembersRouteImport } from './routes/_app/o/$organizationId/settings/members'
import { Route as AppOOrganizationIdSettingsPrivacyRouteImport } from './routes/_app/o/$organizationId/settings/privacy'
import { Route as AppOOrganizationIdSettingsSecurityRouteImport } from './routes/_app/o/$organizationId/settings/security'
import { Route as AppOOrganizationIdPlatformWorkspacesWorkspaceIdRouteImport } from './routes/_app/o/$organizationId/_platform/workspaces.$workspaceId'

const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const OperatorRouteRoute = OperatorRouteRouteImport.update({
  id: '/operator',
  path: '/operator',
  getParentRoute: () => rootRouteImport,
} as any)
const AppPlatformRouteRoute = AppPlatformRouteRouteImport.update({
  id: '/_platform',
  getParentRoute: () => AppRouteRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthInvitationRoute = AuthInvitationRouteImport.update({
  id: '/invitation',
  path: '/invitation',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthMfaRoute = AuthMfaRouteImport.update({
  id: '/mfa',
  path: '/mfa',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSetup2faRoute = AuthSetup2faRouteImport.update({
  id: '/setup-2fa',
  path: '/setup-2fa',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSignedOutRoute = AuthSignedOutRouteImport.update({
  id: '/signed-out',
  path: '/signed-out',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSocialRoute = AuthSocialRouteImport.update({
  id: '/social',
  path: '/social',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => AuthRouteRoute,
} as any)
const OperatorIndexRoute = OperatorIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OperatorRouteRoute,
} as any)
const OperatorConfigurationRoute = OperatorConfigurationRouteImport.update({
  id: '/configuration',
  path: '/configuration',
  getParentRoute: () => OperatorRouteRoute,
} as any)
const OperatorJobsRoute = OperatorJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => OperatorRouteRoute,
} as any)
const OperatorPlansRoute = OperatorPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => OperatorRouteRoute,
} as any)
const OperatorSecurityRoute = OperatorSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => OperatorRouteRoute,
} as any)
const AppPlatformIndexRoute = AppPlatformIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPlatformRouteRoute,
} as any)
const AppPlatformNotificationsRoute =
  AppPlatformNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppPlatformRouteRoute,
  } as any)
const OperatorOrganizationsIndexRoute =
  OperatorOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => OperatorRouteRoute,
  } as any)
const OperatorOrganizationsOrganizationIdRoute =
  OperatorOrganizationsOrganizationIdRouteImport.update({
    id: '/organizations/$organizationId',
    path: '/organizations/$organizationId',
    getParentRoute: () => OperatorRouteRoute,
  } as any)
const AppPlatformAccountIndexRoute = AppPlatformAccountIndexRouteImport.update({
  id: '/account/',
  path: '/account/',
  getParentRoute: () => AppPlatformRouteRoute,
} as any)
const AppPlatformAccountSecurityRoute =
  AppPlatformAccountSecurityRouteImport.update({
    id: '/account/security',
    path: '/account/security',
    getParentRoute: () => AppPlatformRouteRoute,
  } as any)
const AppPlatformHelpIndexRoute = AppPlatformHelpIndexRouteImport.update({
  id: '/help/',
  path: '/help/',
  getParentRoute: () => AppPlatformRouteRoute,
} as any)
const AppPlatformHelpTopicRoute = AppPlatformHelpTopicRouteImport.update({
  id: '/help/$topic',
  path: '/help/$topic',
  getParentRoute: () => AppPlatformRouteRoute,
} as any)
const AppOOrganizationIdPlatformRouteRoute =
  AppOOrganizationIdPlatformRouteRouteImport.update({
    id: '/o/$organizationId/_platform',
    path: '/o/$organizationId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppOOrganizationIdSettingsRouteRoute =
  AppOOrganizationIdSettingsRouteRouteImport.update({
    id: '/o/$organizationId/settings',
    path: '/o/$organizationId/settings',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppOOrganizationIdPlatformIndexRoute =
  AppOOrganizationIdPlatformIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppOOrganizationIdPlatformRouteRoute,
  } as any)
const AppOOrganizationIdSettingsIndexRoute =
  AppOOrganizationIdSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppOOrganizationIdSettingsRouteRoute,
  } as any)
const AppOOrganizationIdSettingsActivityRoute =
  AppOOrganizationIdSettingsActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => AppOOrganizationIdSettingsRouteRoute,
  } as any)
const AppOOrganizationIdSettingsBillingRoute =
  AppOOrganizationIdSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AppOOrganizationIdSettingsRouteRoute,
  } as any)
const AppOOrganizationIdSettingsBrandingRoute =
  AppOOrganizationIdSettingsBrandingRouteImport.update({
    id: '/branding',
    path: '/branding',
    getParentRoute: () => AppOOrganizationIdSettingsRouteRoute,
  } as any)
const AppOOrganizationIdSettingsDataRoute =
  AppOOrganizationIdSettingsDataRouteImport.update({
    id: '/data',
    path: '/data',
    getParentRoute: () => AppOOrganizationIdSettingsRouteRoute,
  } as any)
const AppOOrganizationIdSettingsMembersRoute =
  AppOOrganizationIdSettingsMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AppOOrganizationIdSettingsRouteRoute,
  } as any)
const AppOOrganizationIdSettingsPrivacyRoute =
  AppOOrganizationIdSettingsPrivacyRouteImport.update({
    id: '/privacy',
    path: '/privacy',
    getParentRoute: () => AppOOrganizationIdSettingsRouteRoute,
  } as any)
const AppOOrganizationIdSettingsSecurityRoute =
  AppOOrganizationIdSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AppOOrganizationIdSettingsRouteRoute,
  } as any)
const AppOOrganizationIdPlatformWorkspacesWorkspaceIdRoute =
  AppOOrganizationIdPlatformWorkspacesWorkspaceIdRouteImport.update({
    id: '/workspaces/$workspaceId',
    path: '/workspaces/$workspaceId',
    getParentRoute: () => AppOOrganizationIdPlatformRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppPlatformIndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/operator': typeof OperatorRouteRouteWithChildren
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/invitation': typeof AuthInvitationRoute
  '/auth/mfa': typeof AuthMfaRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/setup-2fa': typeof AuthSetup2faRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/signed-out': typeof AuthSignedOutRoute
  '/auth/social': typeof AuthSocialRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/operator/configuration': typeof OperatorConfigurationRoute
  '/operator/jobs': typeof OperatorJobsRoute
  '/operator/plans': typeof OperatorPlansRoute
  '/operator/security': typeof OperatorSecurityRoute
  '/operator/': typeof OperatorIndexRoute
  '/notifications': typeof AppPlatformNotificationsRoute
  '/operator/organizations/$organizationId': typeof OperatorOrganizationsOrganizationIdRoute
  '/operator/organizations/': typeof OperatorOrganizationsIndexRoute
  '/o/$organizationId': typeof AppOOrganizationIdPlatformRouteRouteWithChildren
  '/o/$organizationId/settings': typeof AppOOrganizationIdSettingsRouteRouteWithChildren
  '/account/security': typeof AppPlatformAccountSecurityRoute
  '/help/$topic': typeof AppPlatformHelpTopicRoute
  '/account/': typeof AppPlatformAccountIndexRoute
  '/help/': typeof AppPlatformHelpIndexRoute
  '/o/$organizationId/settings/activity': typeof AppOOrganizationIdSettingsActivityRoute
  '/o/$organizationId/settings/billing': typeof AppOOrganizationIdSettingsBillingRoute
  '/o/$organizationId/settings/branding': typeof AppOOrganizationIdSettingsBrandingRoute
  '/o/$organizationId/settings/data': typeof AppOOrganizationIdSettingsDataRoute
  '/o/$organizationId/settings/members': typeof AppOOrganizationIdSettingsMembersRoute
  '/o/$organizationId/settings/privacy': typeof AppOOrganizationIdSettingsPrivacyRoute
  '/o/$organizationId/settings/security': typeof AppOOrganizationIdSettingsSecurityRoute
  '/o/$organizationId/': typeof AppOOrganizationIdPlatformIndexRoute
  '/o/$organizationId/settings/': typeof AppOOrganizationIdSettingsIndexRoute
  '/o/$organizationId/workspaces/$workspaceId': typeof AppOOrganizationIdPlatformWorkspacesWorkspaceIdRoute
}
export interface FileRoutesByTo {
  '/': typeof AppPlatformIndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/invitation': typeof AuthInvitationRoute
  '/auth/mfa': typeof AuthMfaRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/setup-2fa': typeof AuthSetup2faRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/signed-out': typeof AuthSignedOutRoute
  '/auth/social': typeof AuthSocialRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/operator/configuration': typeof OperatorConfigurationRoute
  '/operator/jobs': typeof OperatorJobsRoute
  '/operator/plans': typeof OperatorPlansRoute
  '/operator/security': typeof OperatorSecurityRoute
  '/operator': typeof OperatorIndexRoute
  '/notifications': typeof AppPlatformNotificationsRoute
  '/operator/organizations/$organizationId': typeof OperatorOrganizationsOrganizationIdRoute
  '/operator/organizations': typeof OperatorOrganizationsIndexRoute
  '/account/security': typeof AppPlatformAccountSecurityRoute
  '/help/$topic': typeof AppPlatformHelpTopicRoute
  '/account': typeof AppPlatformAccountIndexRoute
  '/help': typeof AppPlatformHelpIndexRoute
  '/o/$organizationId/settings/activity': typeof AppOOrganizationIdSettingsActivityRoute
  '/o/$organizationId/settings/billing': typeof AppOOrganizationIdSettingsBillingRoute
  '/o/$organizationId/settings/branding': typeof AppOOrganizationIdSettingsBrandingRoute
  '/o/$organizationId/settings/data': typeof AppOOrganizationIdSettingsDataRoute
  '/o/$organizationId/settings/members': typeof AppOOrganizationIdSettingsMembersRoute
  '/o/$organizationId/settings/privacy': typeof AppOOrganizationIdSettingsPrivacyRoute
  '/o/$organizationId/settings/security': typeof AppOOrganizationIdSettingsSecurityRoute
  '/o/$organizationId': typeof AppOOrganizationIdPlatformIndexRoute
  '/o/$organizationId/settings': typeof AppOOrganizationIdSettingsIndexRoute
  '/o/$organizationId/workspaces/$workspaceId': typeof AppOOrganizationIdPlatformWorkspacesWorkspaceIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/operator': typeof OperatorRouteRouteWithChildren
  '/_app/_platform': typeof AppPlatformRouteRouteWithChildren
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/invitation': typeof AuthInvitationRoute
  '/auth/mfa': typeof AuthMfaRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/setup-2fa': typeof AuthSetup2faRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/signed-out': typeof AuthSignedOutRoute
  '/auth/social': typeof AuthSocialRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/operator/configuration': typeof OperatorConfigurationRoute
  '/operator/jobs': typeof OperatorJobsRoute
  '/operator/plans': typeof OperatorPlansRoute
  '/operator/security': typeof OperatorSecurityRoute
  '/operator/': typeof OperatorIndexRoute
  '/_app/_platform/notifications': typeof AppPlatformNotificationsRoute
  '/operator/organizations/$organizationId': typeof OperatorOrganizationsOrganizationIdRoute
  '/_app/_platform/': typeof AppPlatformIndexRoute
  '/operator/organizations/': typeof OperatorOrganizationsIndexRoute
  '/_app/o/$organizationId/_platform': typeof AppOOrganizationIdPlatformRouteRouteWithChildren
  '/_app/o/$organizationId/settings': typeof AppOOrganizationIdSettingsRouteRouteWithChildren
  '/_app/_platform/account/security': typeof AppPlatformAccountSecurityRoute
  '/_app/_platform/help/$topic': typeof AppPlatformHelpTopicRoute
  '/_app/_platform/account/': typeof AppPlatformAccountIndexRoute
  '/_app/_platform/help/': typeof AppPlatformHelpIndexRoute
  '/_app/o/$organizationId/settings/activity': typeof AppOOrganizationIdSettingsActivityRoute
  '/_app/o/$organizationId/settings/billing': typeof AppOOrganizationIdSettingsBillingRoute
  '/_app/o/$organizationId/settings/branding': typeof AppOOrganizationIdSettingsBrandingRoute
  '/_app/o/$organizationId/settings/data': typeof AppOOrganizationIdSettingsDataRoute
  '/_app/o/$organizationId/settings/members': typeof AppOOrganizationIdSettingsMembersRoute
  '/_app/o/$organizationId/settings/privacy': typeof AppOOrganizationIdSettingsPrivacyRoute
  '/_app/o/$organizationId/settings/security': typeof AppOOrganizationIdSettingsSecurityRoute
  '/_app/o/$organizationId/_platform/': typeof AppOOrganizationIdPlatformIndexRoute
  '/_app/o/$organizationId/settings/': typeof AppOOrganizationIdSettingsIndexRoute
  '/_app/o/$organizationId/_platform/workspaces/$workspaceId': typeof AppOOrganizationIdPlatformWorkspacesWorkspaceIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/operator'
    | '/auth/forgot-password'
    | '/auth/invitation'
    | '/auth/mfa'
    | '/auth/reset-password'
    | '/auth/setup-2fa'
    | '/auth/sign-in'
    | '/auth/signed-out'
    | '/auth/social'
    | '/auth/verify-email'
    | '/operator/configuration'
    | '/operator/jobs'
    | '/operator/plans'
    | '/operator/security'
    | '/operator/'
    | '/notifications'
    | '/operator/organizations/$organizationId'
    | '/operator/organizations/'
    | '/o/$organizationId'
    | '/o/$organizationId/settings'
    | '/account/security'
    | '/help/$topic'
    | '/account/'
    | '/help/'
    | '/o/$organizationId/settings/activity'
    | '/o/$organizationId/settings/billing'
    | '/o/$organizationId/settings/branding'
    | '/o/$organizationId/settings/data'
    | '/o/$organizationId/settings/members'
    | '/o/$organizationId/settings/privacy'
    | '/o/$organizationId/settings/security'
    | '/o/$organizationId/'
    | '/o/$organizationId/settings/'
    | '/o/$organizationId/workspaces/$workspaceId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/auth/forgot-password'
    | '/auth/invitation'
    | '/auth/mfa'
    | '/auth/reset-password'
    | '/auth/setup-2fa'
    | '/auth/sign-in'
    | '/auth/signed-out'
    | '/auth/social'
    | '/auth/verify-email'
    | '/operator/configuration'
    | '/operator/jobs'
    | '/operator/plans'
    | '/operator/security'
    | '/operator'
    | '/notifications'
    | '/operator/organizations/$organizationId'
    | '/operator/organizations'
    | '/account/security'
    | '/help/$topic'
    | '/account'
    | '/help'
    | '/o/$organizationId/settings/activity'
    | '/o/$organizationId/settings/billing'
    | '/o/$organizationId/settings/branding'
    | '/o/$organizationId/settings/data'
    | '/o/$organizationId/settings/members'
    | '/o/$organizationId/settings/privacy'
    | '/o/$organizationId/settings/security'
    | '/o/$organizationId'
    | '/o/$organizationId/settings'
    | '/o/$organizationId/workspaces/$workspaceId'
  id:
    | '__root__'
    | '/_app'
    | '/auth'
    | '/operator'
    | '/_app/_platform'
    | '/auth/forgot-password'
    | '/auth/invitation'
    | '/auth/mfa'
    | '/auth/reset-password'
    | '/auth/setup-2fa'
    | '/auth/sign-in'
    | '/auth/signed-out'
    | '/auth/social'
    | '/auth/verify-email'
    | '/operator/configuration'
    | '/operator/jobs'
    | '/operator/plans'
    | '/operator/security'
    | '/operator/'
    | '/_app/_platform/notifications'
    | '/operator/organizations/$organizationId'
    | '/_app/_platform/'
    | '/operator/organizations/'
    | '/_app/o/$organizationId/_platform'
    | '/_app/o/$organizationId/settings'
    | '/_app/_platform/account/security'
    | '/_app/_platform/help/$topic'
    | '/_app/_platform/account/'
    | '/_app/_platform/help/'
    | '/_app/o/$organizationId/settings/activity'
    | '/_app/o/$organizationId/settings/billing'
    | '/_app/o/$organizationId/settings/branding'
    | '/_app/o/$organizationId/settings/data'
    | '/_app/o/$organizationId/settings/members'
    | '/_app/o/$organizationId/settings/privacy'
    | '/_app/o/$organizationId/settings/security'
    | '/_app/o/$organizationId/_platform/'
    | '/_app/o/$organizationId/settings/'
    | '/_app/o/$organizationId/_platform/workspaces/$workspaceId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  OperatorRouteRoute: typeof OperatorRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/operator': {
      id: '/operator'
      path: '/operator'
      fullPath: '/operator'
      preLoaderRoute: typeof OperatorRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/_platform': {
      id: '/_app/_platform'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppPlatformRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/invitation': {
      id: '/auth/invitation'
      path: '/invitation'
      fullPath: '/auth/invitation'
      preLoaderRoute: typeof AuthInvitationRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/mfa': {
      id: '/auth/mfa'
      path: '/mfa'
      fullPath: '/auth/mfa'
      preLoaderRoute: typeof AuthMfaRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/setup-2fa': {
      id: '/auth/setup-2fa'
      path: '/setup-2fa'
      fullPath: '/auth/setup-2fa'
      preLoaderRoute: typeof AuthSetup2faRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/sign-in': {
      id: '/auth/sign-in'
      path: '/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/signed-out': {
      id: '/auth/signed-out'
      path: '/signed-out'
      fullPath: '/auth/signed-out'
      preLoaderRoute: typeof AuthSignedOutRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/social': {
      id: '/auth/social'
      path: '/social'
      fullPath: '/auth/social'
      preLoaderRoute: typeof AuthSocialRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/verify-email': {
      id: '/auth/verify-email'
      path: '/verify-email'
      fullPath: '/auth/verify-email'
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/operator/': {
      id: '/operator/'
      path: '/'
      fullPath: '/operator/'
      preLoaderRoute: typeof OperatorIndexRouteImport
      parentRoute: typeof OperatorRouteRoute
    }
    '/operator/configuration': {
      id: '/operator/configuration'
      path: '/configuration'
      fullPath: '/operator/configuration'
      preLoaderRoute: typeof OperatorConfigurationRouteImport
      parentRoute: typeof OperatorRouteRoute
    }
    '/operator/jobs': {
      id: '/operator/jobs'
      path: '/jobs'
      fullPath: '/operator/jobs'
      preLoaderRoute: typeof OperatorJobsRouteImport
      parentRoute: typeof OperatorRouteRoute
    }
    '/operator/plans': {
      id: '/operator/plans'
      path: '/plans'
      fullPath: '/operator/plans'
      preLoaderRoute: typeof OperatorPlansRouteImport
      parentRoute: typeof OperatorRouteRoute
    }
    '/operator/security': {
      id: '/operator/security'
      path: '/security'
      fullPath: '/operator/security'
      preLoaderRoute: typeof OperatorSecurityRouteImport
      parentRoute: typeof OperatorRouteRoute
    }
    '/_app/_platform/': {
      id: '/_app/_platform/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppPlatformIndexRouteImport
      parentRoute: typeof AppPlatformRouteRoute
    }
    '/_app/_platform/notifications': {
      id: '/_app/_platform/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppPlatformNotificationsRouteImport
      parentRoute: typeof AppPlatformRouteRoute
    }
    '/operator/organizations/': {
      id: '/operator/organizations/'
      path: '/organizations'
      fullPath: '/operator/organizations/'
      preLoaderRoute: typeof OperatorOrganizationsIndexRouteImport
      parentRoute: typeof OperatorRouteRoute
    }
    '/operator/organizations/$organizationId': {
      id: '/operator/organizations/$organizationId'
      path: '/organizations/$organizationId'
      fullPath: '/operator/organizations/$organizationId'
      preLoaderRoute: typeof OperatorOrganizationsOrganizationIdRouteImport
      parentRoute: typeof OperatorRouteRoute
    }
    '/_app/_platform/account/': {
      id: '/_app/_platform/account/'
      path: '/account'
      fullPath: '/account/'
      preLoaderRoute: typeof AppPlatformAccountIndexRouteImport
      parentRoute: typeof AppPlatformRouteRoute
    }
    '/_app/_platform/account/security': {
      id: '/_app/_platform/account/security'
      path: '/account/security'
      fullPath: '/account/security'
      preLoaderRoute: typeof AppPlatformAccountSecurityRouteImport
      parentRoute: typeof AppPlatformRouteRoute
    }
    '/_app/_platform/help/': {
      id: '/_app/_platform/help/'
      path: '/help'
      fullPath: '/help/'
      preLoaderRoute: typeof AppPlatformHelpIndexRouteImport
      parentRoute: typeof AppPlatformRouteRoute
    }
    '/_app/_platform/help/$topic': {
      id: '/_app/_platform/help/$topic'
      path: '/help/$topic'
      fullPath: '/help/$topic'
      preLoaderRoute: typeof AppPlatformHelpTopicRouteImport
      parentRoute: typeof AppPlatformRouteRoute
    }
    '/_app/o/$organizationId/_platform': {
      id: '/_app/o/$organizationId/_platform'
      path: '/o/$organizationId'
      fullPath: '/o/$organizationId'
      preLoaderRoute: typeof AppOOrganizationIdPlatformRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/o/$organizationId/settings': {
      id: '/_app/o/$organizationId/settings'
      path: '/o/$organizationId/settings'
      fullPath: '/o/$organizationId/settings'
      preLoaderRoute: typeof AppOOrganizationIdSettingsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/o/$organizationId/_platform/': {
      id: '/_app/o/$organizationId/_platform/'
      path: '/'
      fullPath: '/o/$organizationId/'
      preLoaderRoute: typeof AppOOrganizationIdPlatformIndexRouteImport
      parentRoute: typeof AppOOrganizationIdPlatformRouteRoute
    }
    '/_app/o/$organizationId/settings/': {
      id: '/_app/o/$organizationId/settings/'
      path: '/'
      fullPath: '/o/$organizationId/settings/'
      preLoaderRoute: typeof AppOOrganizationIdSettingsIndexRouteImport
      parentRoute: typeof AppOOrganizationIdSettingsRouteRoute
    }
    '/_app/o/$organizationId/settings/activity': {
      id: '/_app/o/$organizationId/settings/activity'
      path: '/activity'
      fullPath: '/o/$organizationId/settings/activity'
      preLoaderRoute: typeof AppOOrganizationIdSettingsActivityRouteImport
      parentRoute: typeof AppOOrganizationIdSettingsRouteRoute
    }
    '/_app/o/$organizationId/settings/billing': {
      id: '/_app/o/$organizationId/settings/billing'
      path: '/billing'
      fullPath: '/o/$organizationId/settings/billing'
      preLoaderRoute: typeof AppOOrganizationIdSettingsBillingRouteImport
      parentRoute: typeof AppOOrganizationIdSettingsRouteRoute
    }
    '/_app/o/$organizationId/settings/branding': {
      id: '/_app/o/$organizationId/settings/branding'
      path: '/branding'
      fullPath: '/o/$organizationId/settings/branding'
      preLoaderRoute: typeof AppOOrganizationIdSettingsBrandingRouteImport
      parentRoute: typeof AppOOrganizationIdSettingsRouteRoute
    }
    '/_app/o/$organizationId/settings/data': {
      id: '/_app/o/$organizationId/settings/data'
      path: '/data'
      fullPath: '/o/$organizationId/settings/data'
      preLoaderRoute: typeof AppOOrganizationIdSettingsDataRouteImport
      parentRoute: typeof AppOOrganizationIdSettingsRouteRoute
    }
    '/_app/o/$organizationId/settings/members': {
      id: '/_app/o/$organizationId/settings/members'
      path: '/members'
      fullPath: '/o/$organizationId/settings/members'
      preLoaderRoute: typeof AppOOrganizationIdSettingsMembersRouteImport
      parentRoute: typeof AppOOrganizationIdSettingsRouteRoute
    }
    '/_app/o/$organizationId/settings/privacy': {
      id: '/_app/o/$organizationId/settings/privacy'
      path: '/privacy'
      fullPath: '/o/$organizationId/settings/privacy'
      preLoaderRoute: typeof AppOOrganizationIdSettingsPrivacyRouteImport
      parentRoute: typeof AppOOrganizationIdSettingsRouteRoute
    }
    '/_app/o/$organizationId/settings/security': {
      id: '/_app/o/$organizationId/settings/security'
      path: '/security'
      fullPath: '/o/$organizationId/settings/security'
      preLoaderRoute: typeof AppOOrganizationIdSettingsSecurityRouteImport
      parentRoute: typeof AppOOrganizationIdSettingsRouteRoute
    }
    '/_app/o/$organizationId/_platform/workspaces/$workspaceId': {
      id: '/_app/o/$organizationId/_platform/workspaces/$workspaceId'
      path: '/workspaces/$workspaceId'
      fullPath: '/o/$organizationId/workspaces/$workspaceId'
      preLoaderRoute: typeof AppOOrganizationIdPlatformWorkspacesWorkspaceIdRouteImport
      parentRoute: typeof AppOOrganizationIdPlatformRouteRoute
    }
  }
}

interface AppPlatformRouteRouteChildren {
  AppPlatformNotificationsRoute: typeof AppPlatformNotificationsRoute
  AppPlatformIndexRoute: typeof AppPlatformIndexRoute
  AppPlatformAccountSecurityRoute: typeof AppPlatformAccountSecurityRoute
  AppPlatformHelpTopicRoute: typeof AppPlatformHelpTopicRoute
  AppPlatformAccountIndexRoute: typeof AppPlatformAccountIndexRoute
  AppPlatformHelpIndexRoute: typeof AppPlatformHelpIndexRoute
}

const AppPlatformRouteRouteChildren: AppPlatformRouteRouteChildren = {
  AppPlatformNotificationsRoute: AppPlatformNotificationsRoute,
  AppPlatformIndexRoute: AppPlatformIndexRoute,
  AppPlatformAccountSecurityRoute: AppPlatformAccountSecurityRoute,
  AppPlatformHelpTopicRoute: AppPlatformHelpTopicRoute,
  AppPlatformAccountIndexRoute: AppPlatformAccountIndexRoute,
  AppPlatformHelpIndexRoute: AppPlatformHelpIndexRoute,
}

const AppPlatformRouteRouteWithChildren =
  AppPlatformRouteRoute._addFileChildren(AppPlatformRouteRouteChildren)

interface AppOOrganizationIdPlatformRouteRouteChildren {
  AppOOrganizationIdPlatformIndexRoute: typeof AppOOrganizationIdPlatformIndexRoute
  AppOOrganizationIdPlatformWorkspacesWorkspaceIdRoute: typeof AppOOrganizationIdPlatformWorkspacesWorkspaceIdRoute
}

const AppOOrganizationIdPlatformRouteRouteChildren: AppOOrganizationIdPlatformRouteRouteChildren =
  {
    AppOOrganizationIdPlatformIndexRoute: AppOOrganizationIdPlatformIndexRoute,
    AppOOrganizationIdPlatformWorkspacesWorkspaceIdRoute:
      AppOOrganizationIdPlatformWorkspacesWorkspaceIdRoute,
  }

const AppOOrganizationIdPlatformRouteRouteWithChildren =
  AppOOrganizationIdPlatformRouteRoute._addFileChildren(
    AppOOrganizationIdPlatformRouteRouteChildren,
  )

interface AppOOrganizationIdSettingsRouteRouteChildren {
  AppOOrganizationIdSettingsActivityRoute: typeof AppOOrganizationIdSettingsActivityRoute
  AppOOrganizationIdSettingsBillingRoute: typeof AppOOrganizationIdSettingsBillingRoute
  AppOOrganizationIdSettingsBrandingRoute: typeof AppOOrganizationIdSettingsBrandingRoute
  AppOOrganizationIdSettingsDataRoute: typeof AppOOrganizationIdSettingsDataRoute
  AppOOrganizationIdSettingsMembersRoute: typeof AppOOrganizationIdSettingsMembersRoute
  AppOOrganizationIdSettingsPrivacyRoute: typeof AppOOrganizationIdSettingsPrivacyRoute
  AppOOrganizationIdSettingsSecurityRoute: typeof AppOOrganizationIdSettingsSecurityRoute
  AppOOrganizationIdSettingsIndexRoute: typeof AppOOrganizationIdSettingsIndexRoute
}

const AppOOrganizationIdSettingsRouteRouteChildren: AppOOrganizationIdSettingsRouteRouteChildren =
  {
    AppOOrganizationIdSettingsActivityRoute:
      AppOOrganizationIdSettingsActivityRoute,
    AppOOrganizationIdSettingsBillingRoute:
      AppOOrganizationIdSettingsBillingRoute,
    AppOOrganizationIdSettingsBrandingRoute:
      AppOOrganizationIdSettingsBrandingRoute,
    AppOOrganizationIdSettingsDataRoute: AppOOrganizationIdSettingsDataRoute,
    AppOOrganizationIdSettingsMembersRoute:
      AppOOrganizationIdSettingsMembersRoute,
    AppOOrganizationIdSettingsPrivacyRoute:
      AppOOrganizationIdSettingsPrivacyRoute,
    AppOOrganizationIdSettingsSecurityRoute:
      AppOOrganizationIdSettingsSecurityRoute,
    AppOOrganizationIdSettingsIndexRoute: AppOOrganizationIdSettingsIndexRoute,
  }

const AppOOrganizationIdSettingsRouteRouteWithChildren =
  AppOOrganizationIdSettingsRouteRoute._addFileChildren(
    AppOOrganizationIdSettingsRouteRouteChildren,
  )

interface AppRouteRouteChildren {
  AppPlatformRouteRoute: typeof AppPlatformRouteRouteWithChildren
  AppOOrganizationIdPlatformRouteRoute: typeof AppOOrganizationIdPlatformRouteRouteWithChildren
  AppOOrganizationIdSettingsRouteRoute: typeof AppOOrganizationIdSettingsRouteRouteWithChildren
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppPlatformRouteRoute: AppPlatformRouteRouteWithChildren,
  AppOOrganizationIdPlatformRouteRoute:
    AppOOrganizationIdPlatformRouteRouteWithChildren,
  AppOOrganizationIdSettingsRouteRoute:
    AppOOrganizationIdSettingsRouteRouteWithChildren,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthInvitationRoute: typeof AuthInvitationRoute
  AuthMfaRoute: typeof AuthMfaRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSetup2faRoute: typeof AuthSetup2faRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignedOutRoute: typeof AuthSignedOutRoute
  AuthSocialRoute: typeof AuthSocialRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthInvitationRoute: AuthInvitationRoute,
  AuthMfaRoute: AuthMfaRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSetup2faRoute: AuthSetup2faRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthSignedOutRoute: AuthSignedOutRoute,
  AuthSocialRoute: AuthSocialRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface OperatorRouteRouteChildren {
  OperatorConfigurationRoute: typeof OperatorConfigurationRoute
  OperatorJobsRoute: typeof OperatorJobsRoute
  OperatorPlansRoute: typeof OperatorPlansRoute
  OperatorSecurityRoute: typeof OperatorSecurityRoute
  OperatorIndexRoute: typeof OperatorIndexRoute
  OperatorOrganizationsOrganizationIdRoute: typeof OperatorOrganizationsOrganizationIdRoute
  OperatorOrganizationsIndexRoute: typeof OperatorOrganizationsIndexRoute
}

const OperatorRouteRouteChildren: OperatorRouteRouteChildren = {
  OperatorConfigurationRoute: OperatorConfigurationRoute,
  OperatorJobsRoute: OperatorJobsRoute,
  OperatorPlansRoute: OperatorPlansRoute,
  OperatorSecurityRoute: OperatorSecurityRoute,
  OperatorIndexRoute: OperatorIndexRoute,
  OperatorOrganizationsOrganizationIdRoute:
    OperatorOrganizationsOrganizationIdRoute,
  OperatorOrganizationsIndexRoute: OperatorOrganizationsIndexRoute,
}

const OperatorRouteRouteWithChildren = OperatorRouteRoute._addFileChildren(
  OperatorRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  OperatorRouteRoute: OperatorRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
